import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Notification from '@spotfli/ui/Notification';
import { bookProperty } from '../../../../api/user/property/property';
import styles from '../rent/css/RentBookingForm.module.css';

const BuyBookingForm = ({ propertyId, property, onClose }) => {
    const [formData, setFormData] = useState({
        offerAmount: property?.price || '',
        visitingDate: '',
        visitingTime: '',
        message: '',
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [notificationMessage, setNotificationMessage] = useState('');
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (number, medium, type) => {
        setLoading(true);
        setError(null);

        try {
            const response = await bookProperty(propertyId, formData);

            if (response.success) {
                navigate('/user/bookings', {
                    state: {
                        bookingSuccess: true,
                    }
                });
                setNotificationMessage(response.message);
            }
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            {notificationMessage && (
                <Notification
                    message={notificationMessage}
                    noMessage={() => setNotificationMessage('')}
                />
            )}

            <div className={styles.bookingFormContainer}>
                <div className={styles.formHeader}>
                    {onClose && (
                        <button onClick={onClose} className={styles.closeButton} aria-label="Close">
                            <i className={`fa fa-times ${styles.closeIcon}`} />
                        </button>
                    )}
                    <div className={styles.roomHeader}>
                        <h3 className={styles.roomType}>Purchase {property?.category?.name || 'Property'}</h3>
                    </div>
                    <div className={styles.yearlyPrice}>
                        <span className={styles.yearlyLabel}>Asking Price:</span>
                        <span className={styles.yearlyAmount}>XAF {(property?.price)?.toLocaleString() || 'N/A'}</span>
                    </div>
                </div>

                <form className={styles.bookingForm}>
                    <div className={styles.formGroup}>
                        <label className={styles.formLabel}>
                            <span className={styles.labelIcon}><i className="fa fa-money" /></span>
                            Your Offer Amount (XAF) (Optional)
                        </label>
                        <input
                            type="number"
                            name="offerAmount"
                            value={formData.offerAmount}
                            onChange={handleChange}
                            className={styles.formInput}
                        />
                    </div>

                    <div className={styles.formGroup}>
                        <label className={styles.formLabel}>
                            <span className={styles.labelIcon}><i className="fa fa-calendar" /></span>
                            Preferred Visiting Date (Optional)
                        </label>
                        <input
                            type="date"
                            name="visitingDate"
                            value={formData.visitingDate}
                            onChange={handleChange}
                            className={styles.formInput}
                        />
                    </div>

                    <div className={styles.formGroup}>
                        <label className={styles.formLabel}>
                            <span className={styles.labelIcon}><i className="fa fa-clock-o" /></span>
                            Preferred Visiting Time (Optional)
                        </label>
                        <input
                            type="time"
                            name="visitingTime"
                            value={formData.visitingTime}
                            onChange={handleChange}
                            className={styles.formInput}
                        />
                    </div>

                    <div className={styles.formGroup}>
                        <label className={styles.formLabel}>
                            <span className={styles.labelIcon}><i className="fa fa-comment" /></span>
                            Message to Seller
                        </label>
                        <textarea
                            name="message"
                            value={formData.message}
                            onChange={handleChange}
                            rows="4"
                            placeholder="Introduce yourself and explain your offer..."
                            className={styles.formTextarea}
                        />
                    </div>

                    {error && (
                        <div className={styles.errorMessage}>
                            <i className={`fa fa-exclamation-triangle ${styles.errorIcon}`} />
                            {error}
                        </div>
                    )}

                    <button
                        type="button"
                        className={styles.bookButton}
                        disabled={loading}
                        onClick={(e) => {
                            e.preventDefault();
                            handleSubmit('none', 'none', 'booking');
                        }}
                    >
                        {loading ? (
                            <>
                                <span className={styles.loadingSpinner}></span>
                                Processing...
                            </>
                        ) : (
                            <>
                                <span className={styles.buttonIcon}><i className="fa fa-check" /></span>
                                Request Purchase
                                <i className={`fa fa-arrow-right ${styles.buttonArrow}`} />
                            </>
                        )}
                    </button>
                </form>

                <div className={styles.formFooter}>
                    <p className={styles.footerText}>
                        <span className={styles.footerIcon}><i className="fa fa-lock" /></span>
                        Secure transaction • Best price guaranteed
                    </p>
                </div>
            </div>
        </>
    );
};

export default BuyBookingForm;
